import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  feedBackDetails: null,
  addFields:[],
  isAllowPost:true,
  postAnoumous:false,
  basicLanguages:{},
  defaultLanguage:'',
  languageData:[],

};
export const addGuestSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    updateLanguageData: (state, action) => {
      state.languageData = action.payload;
    },
    updateDefaultLanguage: (state, action) => {
      state.defaultLanguage = action.payload;
    },
    updateFeedbackDetails: (state, action) => {
      state.feedBackDetails = action.payload;
    },
    setAddFields: (state, action) => {
        state.addFields = action.payload;
    },
    setAllowPost: (state, action) => {
      state.isAllowPost = action.payload;
    },
    setPostAnoumous: (state, action) => {
      state.postAnoumous = action.payload;
    },
    setBasicLanguages: (state, action) => {
        state.basicLanguages = action.payload;
    },
  },
});
export const {
    updateFeedbackDetails,
    setAddFields,
    setAllowPost,
    setPostAnoumous,
    setBasicLanguages,
    updateDefaultLanguage,
    updateLanguageData
} = addGuestSlice.actions;

export default addGuestSlice.reducer;